import {Component, Input} from '@angular/core';
import { AlertComponent as AlertComponent_1 } from 'ngx-bootstrap/alert';

@Component({
    selector: 'dynamica-alert-component',
    templateUrl: './alert.component.html',
    styles: [],
    imports: [AlertComponent_1]
})
export class AlertComponent {
  @Input() type;
  @Input() msg;
  @Input() status;
}
